import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "roomTableTr"
}
const _hoisted_2 = {
  key: 1,
  class: "fixedAppoContent pad8"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "fs10 fr greyColor",
  style: {"margin-right":"10px"}
}
const _hoisted_5 = {
  key: 1,
  class: "fl fs12 greyColor mt2 ml15"
}
const _hoisted_6 = {
  key: 2,
  class: "lgreyBg fs12 pad5 ml15 rad5 fl"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`fl fw400 pointer ml10 mb10`),
  style: {"margin-top":"0px"}
}
const _hoisted_11 = {
  key: 0,
  class: "fs12 fw600"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "fl" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = ["onMouseover"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "grey" }
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src", "onClick"]
const _hoisted_22 = ["src", "onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = {
  key: 1,
  class: "fr arial centered",
  style: {"margin-top":"-10px"}
}
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = {
  key: 0,
  style: {"width":"100px"},
  class: /*#__PURE__*/_normalizeClass(`fr mr20`)
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_RoomCellEditMenu = _resolveComponent("RoomCellEditMenu")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.parg)
    ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
        (!_ctx.isSP)
          ? (_openBlock(), _createElementBlock("td", {
              key: 0,
              class: _normalizeClass(`roomTableTd centered ${_ctx.bgColor()} posRe`),
              style: {"width":"120px"}
            }, [
              _createElementVNode("div", null, [
                (_ctx.parg)
                  ? (_openBlock(), _createBlock(_component_tooltip, {
                      key: 0,
                      text: "コピーしました!",
                      trigger: "manual",
                      modelValue: _ctx.showTip,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showTip) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", {
                          class: "fs10 ddgreyColor",
                          style: {"line-height":"12px"},
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyPublicId && _ctx.copyPublicId(...args)))
                        }, _toDisplayString(_ctx.parg.public_id), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createElementVNode("label", {
                  class: _normalizeClass(`fs11 ${_ctx.roomLabels()}`)
                }, _toDisplayString(_ctx.roomLabelName), 3),
                (_ctx.appo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_tooltip, {
                        text: "コピーしました!",
                        trigger: "manual",
                        modelValue: _ctx.showAppoTip,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showAppoTip) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_ctx.appo.status == 10)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                class: "fs11 ddgreyColor",
                                style: {"line-height":"12px"},
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyAppoText && _ctx.copyAppoText(...args)))
                              }, _toDisplayString(_ctx.appo.jp_format), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (_ctx.selectedMagTeamName)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "circle_button fs11",
                            style: {"padding":"2px 15px","border":"1px solid #3d543d"},
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.searchByMag && _ctx.searchByMag(...args)))
                          }, [
                            _createTextVNode(" 担当: "),
                            _createElementVNode("span", null, _toDisplayString(_ctx.truncate(_ctx.selectedMagTeamName, 5)), 1)
                          ])), [
                            [
                              _directive_tooltip,
                              _ctx.selectedMagTeamName,
                              void 0,
                              { bottom: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_3
              ])
            ], 2))
          : (_openBlock(), _createElementBlock("td", {
              key: 1,
              class: _normalizeClass(`roomTableTd ${_ctx.bgColor()}`),
              style: {"width":"2px"}
            }, null, 2)),
        _createElementVNode("td", {
          colspan: "2",
          onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openPargProgress && _ctx.openPargProgress(...args)), ["self"])),
          style: {},
          class: _normalizeClass(`posRe roomTableTd`)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(`${_ctx.isSP ? `fs16 posRe w100 mt20` : `fs15`} pad10 fl fw600`),
            style: _normalizeStyle(_ctx.isSP ? {} : _ctx.hasImage ? { width: `calc( 100% - 110px )` } : { width: `100%` })
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(`fl ${_ctx.isSP ? `fs18 mb10` : ``}`)
            }, "■ " + _toDisplayString(_ctx.title), 3),
            (_ctx.isSP && _ctx.parg.expired_at && _ctx.parg.expired_at != -1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.Util.getTimeDateFormatFromSeconds(_ctx.parg.last_block_updated_at, `yyyy/MM/dd HH:mm`)), 1))
              : _createCommentVNode("", true),
            (!_ctx.isSP)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createTextVNode(" 最終更新 "),
                  _createElementVNode("span", null, _toDisplayString(_ctx.Util.getTimeFullFormatFromSeconds(_ctx.parg.last_block_updated_at, "yyyy/MM/dd HH:mm")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.appo)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/watch2.png`),
                    width: "14",
                    height: "14",
                    class: "fl mr4 ml2"
                  }, null, 8, _hoisted_7),
                  _createTextVNode(" " + _toDisplayString(_ctx.appo.duration) + "分 ", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.parg.room_type == `public_room`)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: "fl ml15 dgrey fs12 lgreyBg padw4 rad5 pointer fw400 hoverGreyBg",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.editPrivateMemo && _ctx.editPrivateMemo(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/create_event.png`),
                    style: {"width":"14px","height":"15px","margin-top":"-4px"}
                  }, null, 8, _hoisted_8),
                  _createTextVNode(" 管理用に設定 ")
                ]))
              : _createCommentVNode("", true),
            _hoisted_9
          ], 6),
          (_ctx.parg.step_rooms_dic)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_ctx.parg.current_block_type)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (!['fixed', 'canceled'].includes(_ctx.parg.current_block_type))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (_ctx.parg.last_block_updated_at > _ctx.DateTime.now().minus({ days: 1 }).toSeconds())
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/status_play.png`),
                                  width: "12",
                                  height: "14",
                                  class: "fl ml2"
                                }, null, 8, _hoisted_13))
                              : (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/status_suspend.png`),
                                  width: "12",
                                  height: "14",
                                  class: "fl mr1 ml2"
                                }, null, 8, _hoisted_14))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.ParentRoomGroup.blockTypeText(_ctx.parg.current_block_type)), 1),
                      _hoisted_16
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parg.step_rooms_dic.block_1, (_mem, memindex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(`${_ctx.isSP ? `fs14` : `fs14 fw600 pointer`}`),
                    style: {"line-height":"24px"},
                    key: memindex,
                    onMouseover: ($event: any) => (_ctx.mouseoverMember(_mem, memindex)),
                    onMouseleave: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.mouseleaveMember && _ctx.mouseleaveMember(...args)))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`fl mr5 ${_ctx.currentMemIndex == memindex ? `bb1` : ``}`)
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_mem.name), 1),
                      (_mem.company_name)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(`dgrey ${_ctx.isSP ? `fs12` : `fs12`}`)
                          }, "(" + _toDisplayString(_mem.company_name) + ")", 3))
                        : _createCommentVNode("", true)
                    ], 2),
                    (_ctx.Util.isPresent(_mem.private_memo))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "fl mr5 pointer",
                          onClick: ($event: any) => (_ctx.clickFormMember(_mem))
                        }, [
                          _createElementVNode("span", _hoisted_19, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/chat.png`),
                              class: "mr3",
                              style: {"width":"18px","margin-top":"-2px"}
                            }, null, 8, _hoisted_20),
                            _createTextVNode(_toDisplayString(_ctx.truncate(_mem.private_memo, 10)), 1)
                          ])
                        ], 8, _hoisted_18))
                      : _createCommentVNode("", true),
                    (false && _ctx.currentMemIndex == memindex)
                      ? _withDirectives((_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.$getAssetImageUrl(`/assets/icons/search_icon.png`),
                          width: "16",
                          height: "17",
                          class: "pointer ml5",
                          onClick: ($event: any) => (_ctx.searchByMember(_mem))
                        }, null, 8, _hoisted_21)), [
                          [_directive_tooltip, `このメンバーの調整ページを検索`]
                        ])
                      : _createCommentVNode("", true),
                    (false && _ctx.currentMemIndex == memindex && _mem.answered_status == `done`)
                      ? _withDirectives((_openBlock(), _createElementBlock("img", {
                          key: 2,
                          src: _ctx.$getAssetImageUrl(`/assets/icons/form_icon.png`),
                          width: "16",
                          height: "17",
                          class: "pointer ml5",
                          onClick: ($event: any) => (_ctx.clickFormMember(_mem))
                        }, null, 8, _hoisted_22)), [
                          [_directive_tooltip, `フォーム確認`]
                        ])
                      : _createCommentVNode("", true),
                    _hoisted_23
                  ], 42, _hoisted_17))
                }), 128)),
                _hoisted_24
              ]))
            : _createCommentVNode("", true),
          (_ctx.parg.memo)
            ? (_openBlock(), _createElementBlock("p", _hoisted_25, [
                _withDirectives(_createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/memo_bold.png`),
                  width: "20",
                  height: "20",
                  class: "fl pointer",
                  style: {"margin-right":"16px","margin-top":"45px"}
                }, null, 8, _hoisted_26), [
                  [
                    _directive_tooltip,
                    `公開メモ\n${_ctx.parg.memo}`,
                    void 0,
                    { top: true }
                  ]
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_27
        ]),
        _createElementVNode("td", null, [
          (!_ctx.isSP)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createVNode(_component_RoomCellEditMenu, {
                  room: _ctx.parg,
                  canDelete: ![_ctx.Room.STATUS_ACTIVE_CANCELED, _ctx.Room.STATUS_ACTIVE_PAST_FIXED].includes(_ctx.parg.status),
                  onCopyPage: ($event: any) => (null),
                  onEditPage: ($event: any) => (null),
                  onShowCloseRoomModal: _ctx.showCloseRoomModal,
                  onGoSummary: ($event: any) => (null),
                  onGoSummaryNotFixed: ($event: any) => (null),
                  onCancelVoted: ($event: any) => (null),
                  onCancelAppo: _ctx.cancelAppo,
                  onChangeActive: _ctx.changeActive
                }, null, 8, ["room", "canDelete", "onShowCloseRoomModal", "onCancelAppo", "onChangeActive"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("label", {
            class: _normalizeClass(`circle_button fw600 fr centered fs12 blueAround hoverSkyblueBg`),
            style: {"width":"110px","padding":"4px 10px"},
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openPargProgress && _ctx.openPargProgress(...args)))
          }, " 進捗を確認 ")
        ])
      ]))
    : _createCommentVNode("", true)
}